import API from 'services/API';

export default function getAccountingActions(notificationId) {
  return API.request({
    method: 'GET',
    url: `/accountingActions/pdf?notificationId=${notificationId}`,
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
    },
    responseType: 'arraybuffer',
  });
}
